import React from "react";
import "./Our_process_card.css";
import Play_button from "../../../animation/play_button/Play_button";
import { IDS } from "../../../../utils/IDS";

function Our_process_card({
  img_Src,
  headingText,
  desc_text,
  number,
  vdo_Src,
}) {
  console.log(vdo_Src, "vdo_Src");

  return (
    <>
      <section className="Our_process_card">
        <div className="number_holder">
          <span>{number}</span>
        </div>
        <div className="play_vdo_section_holder">
          <div className="img_holder">
            <video
              className="procces_img"
              controls
              playsInline
              preload="metadata"
            >
              <source src={vdo_Src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
        <div className="text_holder">
          <h4>{headingText}</h4>
          <p>{desc_text}</p>
        </div>
      </section>
    </>
  );
}

export default Our_process_card;
